<script lang="ts">
  import { onMount } from "svelte";

  import Window from "../components/Window.svelte";
  import type { WinCbs, WinProps } from "../scripts/WinTypes";

  import ProcMgr from "../stores/ProcMgr";
  import SessMgr from "../stores/SessMgr";
  import axios from "axios";

  import { getCookie, setCookie } from "../scripts/utils";
  import { addLog } from "../stores/LoggerStore";

  export let winProps: WinProps;
  winProps.name = winProps.name || "API tester";
  let setLoad = () => {},
    setLoaded = () => {};
  const callbacks: WinCbs = {
    onFocus: () => {
      logsElem.focus();
      return true;
    },
    onMount: (setter: (string, any) => void) => {
      addLog("terminal on mount");
      setLoad = () => setter("loading", true);
      setLoaded = () => setter("loading", false);
      return true;
    },
  };

  let logs = [];

  let procmgr = ProcMgr.getInstance();
  let logsElem;

  let logId = 1;
  const log = (log) => {
    console.log(log);
    logs = [...logs, { log: log, id: logId++ }];
  };
  const obj = (log) => JSON.stringify(log);

  onMount(() => {
    log("API Tester - Wire mounted");
    logsElem.focus();
  });

  const _gettest = async (
    api: string,
    local: boolean = true,
    custom?: string
  ) => {
    setLoad();
    // const sessmgr = SessMgr.getInstance();
    // log("Get test : " + JSON.stringify(await sessmgr.dirs()));
    const domain = local
      ? "http://localhost:3000/"
      : "https://jamos-v2.herokuapp.com/";
    const url = !custom ? domain + api : custom;
    log("req to " + url);
    let res = await axios
      .get(url)
      .then((_res) => _res.data)
      .catch((err?) => {
        log(`Error : ${err}`);
        setLoaded();
      });
    if (!res) {
      return undefined;
    }
    log("Test resp : " + JSON.stringify(res));
    setLoaded();
    return res;
  };
  const getLocal = (e) => _gettest("FirstInstance");
  const getRemote = (e) => _gettest("FirstInstance", false);
  const getCustom = (e) => {
    setCookie("_apiUrlValue", apiUrlValue);
    return _gettest("", true, apiUrlValue);
  };
  const getCustom2 = (e) => {
    setCookie("_apiUrlValue2", apiUrlValue2);
    return _gettest("", true, apiUrlValue2);
  };

  const getCustom3 = (e) => {
    setCookie("_apiUrlValue3", apiUrlValue3);
    return _gettest("", true, apiUrlValue3);
  };
  let apiUrlElem: HTMLElement,
    apiUrlElem2: HTMLElement,
    apiUrlElem3: HTMLElement;
  let apiUrlValue = getCookie("_apiUrlValue") || "http://localhost:3000/";
  let apiUrlValue2 =
    getCookie("_apiUrlValue2") || "https://jamos-v2.herokuapp.com/";
  let apiUrlValue3 = getCookie("_apiUrlValue3") || "";
  let handleApiEnter = (e) => {
    if (e.key !== "Enter") {
      return;
    }
    e.preventDefault();

    getCustom(e);
  };
  let handleApiEnter2 = (e) => {
    if (e.key !== "Enter") {
      return;
    }
    e.preventDefault();
    getCustom2(e);
  };
  let handleApiEnter3 = (e) => {
    if (e.key !== "Enter") {
      return;
    }
    e.preventDefault();
    getCustom3(e);
  };
</script>

<Window {winProps} {callbacks}>
  <div class="logs">
    <div class="l">
      <ol bind:this={logsElem}>
        {#each logs as log (log.id)}
          {#await log.log}
            <li>Wating...</li>
          {:then val}
            <li>{val}</li>
          {/await}
        {/each}
      </ol>
    </div>
    <div class="r">
      <div class="r-item h2">
        <div>* API Test. Current environment : {process.env.NODE_ENV}</div>
        <button class="get-test" on:click={getLocal}
          >API Get http://localhost:3000/FirstInstance</button
        >
        <button class="get-test" on:click={getRemote}
          >API Get https://jamos-v2.herokuapp.com/FirstInstance</button
        >
        <div class="empty">_</div>
        <div class="empty">Workbench1</div>
        <textarea
          class="api-url"
          bind:this={apiUrlElem}
          bind:value={apiUrlValue}
          on:keydown={handleApiEnter}
          rows={1}
        />
        <button class="get-test" on:click={getCustom}>API Get &uarr;</button>
        <div class="empty">_</div>
        <div class="empty">Workbench2</div>
        <textarea
          class="api-url"
          bind:this={apiUrlElem2}
          bind:value={apiUrlValue2}
          on:keydown={handleApiEnter2}
          rows={1}
        />
        <button class="get-test" on:click={getCustom2}>API Get &uarr;</button>
        <div class="empty">_</div>
        <div class="empty">Workbench3</div>
        <textarea
          class="api-url"
          bind:this={apiUrlElem3}
          bind:value={apiUrlValue3}
          on:keydown={handleApiEnter3}
          rows={1}
        />
        <button class="get-test" on:click={getCustom3}>API Get &uarr;</button>
      </div>
    </div>
  </div>
</Window>

<style>
  .logs {
    display: flex;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    justify-content: space-between;
  }
  .api-url {
    resize: none;
    white-space: nowrap;
    overflow: hidden;
  }
  .l,
  .r {
    flex: 1;
    overflow: auto;
    padding: 10px;
  }
  .r {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .r-item {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .h2 {
    flex: 2;
  }
  .store-value {
    font-weight: 300;
  }
  ol {
    box-sizing: border-box;
    /* overflow-y: scroll; */
    overflow: auto;
    width: 100%;
    /* height: 100%; */
    padding: 0;
    margin: 0;
    padding-left: 20px;
  }

  li {
    margin: 0;
    margin-bottom: 10px;
    font-size: 1rem;
    word-wrap: break-word;
  }
</style>
